import {HashRouter as Router, Navigate, Route, Routes, useNavigate,} from "react-router-dom";
import "./App.css";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {AuthProvider, useAuth} from "./authContext";

import LoginPage from "./login";
import RegisterPage from "./register";
import PrivateRoute from "./privateRoute";

import ClockInManager from "./manager/clockIn";
import ClockOutManager from "./manager/clockOut";
import PresensiManager from "./manager/presensi";
import DataKaryawan from "./manager/dataKaryawan";
import GajiKaryawan from "./manager/gajiKaryawan";
import ManageEmployee from "./manager/manageEmployee";
import ReviewStokManager from "./manager/reviewStok";
import TipeStokManager from "./manager/tipeStok";
import PemesananManager2 from "./manager/pemesanan2";

import ForgotPage from "./forgot";
import ResetPasswordPage from "./resetPassword";


import PaymentPage from "./customer/paymentPage";
import MoreItemsPage from "./customer/moreItemPage";
import CartPage from "./customer/cartPage";
import WishlistPage from "./customer/wishlistPage";
import ReviewTag from "./manager/tag";
import ReviewBanner from "./manager/banner";
import ReviewRefund from "./manager/reviewRefund";
import HomePage2 from "./customer/homePage2";
import ItemDetailPage2 from "./customer/itemDetailPage2";
import CheckoutPage2 from "./customer/checkoutPage2";
import AboutPage from "./customer/aboutPage";
import ProfilePage from "./customer/profilePage";
import OrderDetailPage from "./customer/orderDetailPage";
import MaintenancePage from "./maintenance/maintenancePage";
import BuyNowPage from "./customer/buyNowPage";
import ReviewDiscount from "./manager/discount";
import PermissionRoute from "./permissionRoute";
import AccessRight from "./manager/accessRight";
import ReviewPartner from "./manager/partner";
import PartnerPemesananPage from "./manager/pemesananPartner";
import PartnerTransaction from "./manager/partnerTransaction";
import Withdrawal from "./manager/withdrawal";
import PartnerProfile from "./manager/partnerProfile";

function AppWrapper() {
  const { auth, getStringNavigateBasedOnRole } = useAuth();
  const hakAkses = auth.user ? auth.user.accessRight : null;
  const webType = process.env.REACT_APP_WEB_TYPE;

  const prefix = "";
  return (
    <Routes>
      {/* <Route path="/" element={<Navigate to="/maintenance"/>}/> */}
      <Route path="/maintenance" element={<MaintenancePage />}></Route>
      <Route path="/" element={<MaintenancePage />}></Route>
      {/* <Route path={`${prefix}/`} element={
        <Navigate to={getStringNavigateBasedOnRole(auth?.user)} />}
      />
      <Route path="/login" element={<LoginPage/>}/>
      <Route path={`${prefix}/forgot`} element={<ForgotPage/>}/>
      <Route path={`${prefix}/resetPassword/verify`} element={<ResetPasswordPage/>}/>
      <Route path={`${prefix}/resetPassword/reset`} element={<ResetPasswordPage/>}/> */}
      
      {/* {
        webType === 'customer' && (
          <>
            <Route path={`${prefix}/register`} element={<RegisterPage/>}/>
            
            <Route path={`${prefix}/home`} element={<HomePage2/>}/>
            <Route path={`${prefix}/items`} element={<MoreItemsPage/>}/>
            <Route path={`${prefix}/item/:id`} element={<ItemDetailPage2/>}/>
            <Route path={`${prefix}/about`} element={<AboutPage />} />

            <Route element={<PrivateRoute roles={[4]}/>}>
              <Route path={`${prefix}/customer/checkoutPage`} element={<CheckoutPage2/>}/>
              <Route path={`${prefix}/customer/buyNow`} element={<BuyNowPage/>}/>
              <Route path={`${prefix}/customer/checkoutPage/:id`} element={<CheckoutPage2/>}/>
              <Route path={`${prefix}/customer/paymentPage`} element={<PaymentPage/>}/>
              <Route path={`${prefix}/customer/order/:id`} element={<OrderDetailPage/>}/>
              <Route path={`${prefix}/customer/cart`} element={<CartPage/>}/>
              <Route path={`${prefix}/customer/wishlist`} element={<WishlistPage/>}/>
              <Route path={`${prefix}/customer/profile`} element={<ProfilePage />} />
            </Route>
          </>
        )
      } */}

      { 
        webType === 'admin' && (
          <>
            {/* MANAGER */}
            <Route element={<PrivateRoute roles={[1, 2, 3, 5, 6]}/>}>
              <Route
                path="/manager/karyawan/presensi"
                element={
                  <PermissionRoute permissionKey="menuAbsensi">
                    <PresensiManager/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/presensi/clockin"
                element={
                  <PermissionRoute permissionKey="menuAbsensi">
                    <ClockInManager/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/presensi/clockout"
                element={
                  <PermissionRoute permissionKey="menuAbsensi">
                    <ClockOutManager/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/dataKaryawan"
                element={
                  <PermissionRoute permissionKey="menuDataKaryawan">
                    <DataKaryawan/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/gajiKaryawan"
                element={
                  <PermissionRoute permissionKey="menuGajiKaryawan">
                    <GajiKaryawan/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/manageEmployee"
                element={
                  <PermissionRoute permissionKey="menuPengaturanKaryawan">
                    <ManageEmployee/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/karyawan/hakAkses"
                element={
                  <PermissionRoute permissionKey="menuHakAkses">
                    <AccessRight />
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/stok/reviewStok"
                element={
                  <PermissionRoute permissionKey="menuKelolaProduk">
                    <ReviewStokManager/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/stok/tipeBarang"
                element={
                  <PermissionRoute permissionKey="menuKelolaSku">
                    <TipeStokManager/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/stok/diskon"
                element={
                  <PermissionRoute permissionKey="menuKelolaDiskon">
                    <ReviewDiscount/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/decoration/tag"
                element={
                  <PermissionRoute permissionKey="menuKelolaTag">
                    <ReviewTag/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/decoration/banner"
                element={
                  <PermissionRoute permissionKey="menuKelolaBanner">
                    <ReviewBanner/>
                  </PermissionRoute>
                }
              />
              
              <Route
                path="/manager/orderDelivery/pemesanan/mitra"
                element={
                  <PermissionRoute permissionKey="menuReviewPesananMitra">
                    <PartnerPemesananPage/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/orderDelivery/mitra/transaksi"
                element={
                  <PermissionRoute permissionKey="menuTransaksiMitra">
                    <PartnerTransaction/>
                  </PermissionRoute>
                }
              />
              <Route
                path="/manager/orderDelivery/pemesanan2"
                element={
                  <PermissionRoute permissionKey="menuReviewPesanan">
                    <PemesananManager2/>
                  </PermissionRoute>
                }
              />
              <Route 
                path="/manager/orderDelivery/refunds"
                element={
                  <PermissionRoute permissionKey="menuReviewRefund">
                    <ReviewRefund />
                  </PermissionRoute>
                }
              />

              <Route
                path="/manager/mitra"
                element={
                  <PermissionRoute permissionKey="menuKelolaMitra">
                    {
                      hakAkses?.position === "Mitra" ? (
                        <PartnerProfile />
                      ) : (
                        <ReviewPartner />
                      )
                    }
                  </PermissionRoute>
                }
              />

              <Route
                path="/manager/orderDelivery/penarikanDana"
                element={
                  <PermissionRoute permissionKey="menuPenarikanDana">
                    <Withdrawal/>
                  </PermissionRoute>
                }
              />
            </Route>
          </>
        )
      }
    </Routes>
  );
}

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <AuthProvider>
          <AppWrapper/>
        </AuthProvider>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
